import { rest } from 'msw';

import { getConfig } from 'shared/config';
import { exclusionsMock, settingsMock } from '.';

const odinAPI = getConfig().odin?.host;

export const handlers = [
  rest.get(`${odinAPI}/yousee/selfcare/subscriptions/:subscriptionId/settings`, (req, res, ctx) =>
    res(ctx.json(settingsMock)),
  ),
  rest.get(
    `${odinAPI}/yousee/selfcare/subscriptions/:subscriptionId/exclusions/:productCode`,
    (req, res, ctx) => res(ctx.json(exclusionsMock)),
  ),
];
